import { render, staticRenderFns } from "./GeolocationSettings.vue?vue&type=template&id=90226c00&scoped=true"
import script from "./GeolocationSettings.vue?vue&type=script&lang=js"
export * from "./GeolocationSettings.vue?vue&type=script&lang=js"
import style0 from "./GeolocationSettings.vue?vue&type=style&index=0&id=90226c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90226c00",
  null
  
)

export default component.exports